export default {
  "content": "<g fill=\"#3F4450\" clip-path=\"url(#a)\"><path d=\"M12 15a4.513 4.513 0 004.5-4.5v-6a4.5 4.5 0 10-9 0v6A4.513 4.513 0 0012 15\"/><path d=\"M21 11.438a1.5 1.5 0 10-3 0c0 2.791-2.691 5.062-6 5.062s-6-2.271-6-5.062a1.5 1.5 0 00-3 0 8.39 8.39 0 007.5 7.94V21h-3a1.5 1.5 0 100 3h9a1.5 1.5 0 100-3h-3v-1.622a8.39 8.39 0 007.5-7.94\"/></g><defs><clipPath id=\"a\"><path fill=\"#fff\" d=\"M0 0h24v24H0z\"/></clipPath></defs>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "24",
    "height": "24",
    "fill": "none"
  }
};